import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/billable-metric/:metricId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    metricId: string;
}
const mutationFn = ({ metricId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { metricId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteBillableMetric };
